<template>
  <div>
    <v-data-table
        style="overflow: hidden;"
        :headers="processedHeaders"
        :items="data"
        :hide-default-footer="hideDefaultFooter"
        disable-pagination
        class="elevation-5 no-border rounded-lg"
    >
      <template #item.descripcion="{ value }">
        <div class="py-3" style="word-wrap: break-word;"
        :style="$vuetify.breakpoint.name !== 'xs' ? 'max-width: 40vw;' : 'max-width: 50vw;'">
          {{ value }}
        </div>
      </template>

      <template #item.nombre="{ value }">
        <div class="py-3" style="word-wrap: break-word;"
              :style="$vuetify.breakpoint.name !== 'xs' ? 'max-width: 40vw;' : 'max-width: 50vw;'">
          {{ value }}
        </div>
      </template>

      <template #item.corr_op="{ value }">
        <div>
          {{ value }}
        </div>
      </template>

      <template v-for="v in slotsColumn" #[`item.${v}`]="{item, index}">
        <slot :name="v" :item="item" :index="index"/>
      </template>
  </v-data-table>

    <!-- Paginación fuera de la tabla: se muestra sólo si hay más de una página -->
    <div class="table-pagination mt-3" v-if="total > 0">
      <app-pagination
        v-model="numPage"
        :total-pages="total"
        @change="changePagina"
        @perPageChange="onPerPageChange"
      />
    </div>
  </div>
</template>

<script>
import AppPagination from "./ComponentPaginationProcess.vue"

export default {
  name: "TablaTabs",
  components: {AppPagination},
  props: {
    headers: {
      type: Array,
      required: true,
    },
    data: {
      type: Array,
      required: true,
    },
    hideDefaultFooter: {
      type: Boolean,
      default: true,
    },
    page: {
      type: Number,
      default: 1,
    },
    totalRegistros: {
      type: Number,
      default: 0,
    },
    por_pagina: {
      type: Number,
      default: 10,
    },
    keyId: {
      type: String
    },
    icon: {
      type: String,
      default: 'mdi-trash-can-outline'
    },
    labelDelete: {
      type: String,
      default: 'Eliminar'
    },
    rol: {
      type: String,
      default: 'unidad'
    },
    slotsColumn: {
      type: Array,
      default: () => ([])
    },
    nombrePagina: {
      type: String,
      default: 'pagina'
    },
    exclude: String
  },
  data() {
    return {
      // counter: 1,
      numPage: 0
    }
  },
  methods: {

    // addCorrelativo(item) {
    //   item.num = this.counter++;
    //   return item;
    // },
    // metodoInput(event){
    //   this.$watch(()=>{
    //     if (this.$parent.$parent.hasOwnProperty(this.nombrePagina)) {
    //       this.$parent.$parent[this.nombrePagina] = event;
    //     }
    //   })
    //   this.$emit('metodoInputEjecutado');
    // },
    // metodoChange(){
    //   this.$emit('metodoChangeEjecutado');
    // },
    changePagina(nuevo, old) {
      this.$emit("paginationChange", nuevo);
    },
    onPerPageChange(perPage) {
      // Emitir hacia el padre para que actualice su paginacion.por_pagina
      this.$emit('perPageChange', perPage);
      // Reiniciar la página actual a 1 localmente y avisar al padre
      this.numPage = 1;
    },
    // deleteItem(item) {
    //   console.log(item);
    //   this.$emit('item-deleted', item); // Emitir el evento con los datos
    // },
    // inputChange(event, item) {
    //   ;
    //   const itemObj = {
    //     id: item.id,
    //     estado: event,
    //   };
    //   this.$emit('item-changed', itemObj); // Emitir el evento con los datos
    // },
  },
  computed: {
    // modifiedTableData() {
    //   return this.data.map(this.addCorrelativo);
    // }
    total() {
      return Math.ceil(this.totalRegistros / this.por_pagina)
    },
    setheader(){
      // Filtrar encabezado excluyendo el valor indicado por la prop `exclude`
      // y también ocultar la columna cuyo texto sea 'N°' (número correlativo).
      return this.headers
        .filter((item) => item.value != this.exclude)
        .filter((item) => (item.text || '').trim() !== 'N°')
    },
    processedHeaders() {
      return this.setheader.map(header => {
        const headerAlign = header['header-align'] || 'center'
        return {
          ...header,
          class: `header-align-${headerAlign}`
        }
      })
    }
  },
  watch: {
    data: function (nuevo, anterior) {
      if(nuevo.length === 0 && this.numPage !== 1){
        this.numPage= 1
      }
    }
  },
  created() {
    this.numPage = this.page
  },
}
</script>

<style lang="scss" scoped>
:deep(tbody tr:nth-of-type(odd)) {
  background-color: #eeeeee
}

// Alineamiento dinámico de headers
:deep(.v-data-table > .v-data-table__wrapper > table > thead > tr > th.header-align-center) {
  text-align: center !important;
}

:deep(.v-data-table > .v-data-table__wrapper > table > thead > tr > th.header-align-start) {
  text-align: start !important;
}

:deep(.v-data-table > .v-data-table__wrapper > table > thead > tr > th.header-align-end) {
  text-align: end !important;
}

.table-pagination{
  width: 100%;
  display: flex;
  justify-content: center;
}

/* Estilos para la tabla con sombra y bordes redondeados */
.tabla-card{
  border-radius: 10px;
  background: #ffffff;
  box-shadow: 0 8px 24px rgba(23, 31, 38, 0.08);
  overflow: hidden; /* para que las esquinas redondeadas recorten la tabla */
}

/* Encabezado más claro como en el ejemplo */
:deep(.tabla-card thead) {
  background-color: #fafafa;
}

:deep(.tabla-card thead th) {
  font-weight: 700;
  color: #1f2937; /* gris oscuro */
  border-bottom: none;
}

/* Hover sutil en filas */
:deep(.tabla-card tbody tr:hover) {
  background-color: rgba(0,0,0,0.03) !important;
}

:deep(.tabla-card .v-data-table__wrapper) {
  background: transparent;
}
</style>
